import styled from "styled-components";

import { PrimaryText } from "@/shared/ui/Typography";

export const StyledSalaryAmount = styled(PrimaryText)`
    color: ${(props) => props.theme.lightBlue} !important;
`;
